// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__b0nTx","header":"ClearentDisclaimer_header__2SlF6","inner":"ClearentDisclaimer_inner__9Wfe0"};